import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProgressSpinnerService } from '../../service/progress-spinner.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  constructor(private readonly router: Router,
              public readonly toastrService: ToastrService,
              public readonly progressSpinnerService: ProgressSpinnerService) {
  }

  successLogin() {
    this.router.navigateByUrl('positions');
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      console.log(event);
    })
  }
}
